export default __webpack_public_path__ + "static/media/upcoming-exam.c83babe1.jpg";